/* Sherrill & Bros. product page behaviour:
   - no option is pre-selected; Add to Cart waits until every option has been chosen
   - size chart / shipping links open as pop-ups
   - sticky Add to Cart bar once the main button scrolls out of view */
(() => {
  const productInfo = document.querySelector('product-info[id^="MainProduct"]');
  if (!productInfo) return;

  const getButton = () => productInfo.querySelector('.product-form__submit');
  const getFieldsets = () => productInfo.querySelectorAll('variant-selects fieldset');

  // --- No pre-selection -------------------------------------------------
  const hasVariantInUrl = new URLSearchParams(window.location.search).has('variant');
  // Options the shopper has chosen, keyed by option name. Names stay stable while the theme
  // swaps the old picker for the re-rendered one (both can briefly be in the DOM).
  const touched = new Set();
  let disabledByUs = false;

  const optionName = (fieldset) =>
    fieldset.querySelector('legend')?.textContent.split(':')[0].trim().toLowerCase() || '';

  const selectedVariant = () => {
    const json = productInfo.querySelector('variant-selects [data-selected-variant]')?.textContent;
    try {
      return json ? JSON.parse(json) : null;
    } catch (error) {
      return null;
    }
  };

  const applyNoPreselection = () => {
    if (hasVariantInUrl) return;
    const fieldsets = Array.from(getFieldsets());
    if (!fieldsets.length) return;

    fieldsets.forEach((fieldset) => {
      if (touched.has(optionName(fieldset))) return;
      fieldset.querySelectorAll('input[type="radio"]:checked').forEach((input) => (input.checked = false));
      const selectedValue = fieldset.querySelector('[data-selected-value]');
      if (selectedValue && selectedValue.textContent !== '') selectedValue.textContent = '';
    });

    const button = getButton();
    const label = button?.querySelector('span');
    if (!button || !label) return;

    const missing = [...new Set(fieldsets.map(optionName))].filter((name) => !touched.has(name));
    if (missing.length) {
      const text = missing.length === 1 ? `Select ${missing[0]}` : 'Select options';
      if (!button.disabled) button.disabled = true;
      if (label.textContent.trim() !== text) label.textContent = text;
      disabledByUs = true;
    } else if (disabledByUs) {
      disabledByUs = false;
      const variant = selectedVariant();
      if (variant && variant.available) {
        button.disabled = false;
        label.textContent = window.variantStrings?.addToCart || 'Add to cart';
      }
    }
  };

  productInfo.addEventListener(
    'change',
    (event) => {
      const fieldset = event.target.closest('variant-selects fieldset');
      if (fieldset) touched.add(optionName(fieldset));
    },
    true
  );

  new MutationObserver(() => applyNoPreselection()).observe(productInfo, { childList: true, subtree: true });
  applyNoPreselection();

  // --- Pop-ups for size chart and shipping links -------------------------
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link || !productInfo.contains(link)) return;
    const href = link.getAttribute('href');
    let modal = null;
    if (/\/pages\/(size-chart|belt-sizing-guide)/.test(href)) modal = document.getElementById('SbSizeModal');
    if (/\/policies\/shipping-policy/.test(href)) modal = document.getElementById('SbShippingModal');
    if (!modal || typeof modal.show !== 'function') return;
    event.preventDefault();
    modal.show(link);
  });

  // --- Sticky Add to Cart ------------------------------------------------
  const bar = document.querySelector('.sb-sticky-atc');
  const barButton = bar?.querySelector('.sb-sticky-atc__button');
  const barPrice = bar?.querySelector('.sb-sticky-atc__price');
  if (!bar || !barButton) return;
  // Move the bar out of product-info so its own updates don't trigger the observers below.
  document.body.appendChild(bar);
  bar.hidden = false;

  const setText = (element, text) => {
    if (element && text && element.textContent !== text) element.textContent = text;
  };

  const syncBar = () => {
    const button = getButton();
    const price = productInfo.querySelector('.price .price-item--last, .price .price-item--regular');
    if (price) setText(barPrice, price.textContent.trim());
    if (button) setText(barButton, button.querySelector('span')?.textContent.trim());
  };

  barButton.addEventListener('click', () => {
    const button = getButton();
    if (!button) return;
    if (button.disabled) {
      const picker = productInfo.querySelector('variant-selects') || button;
      picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    button.click();
  });

  const updateBarVisibility = () => {
    const button = getButton();
    if (!button) return;
    const scrolledPast = button.getBoundingClientRect().bottom < 0;
    if (bar.classList.contains('is-visible') !== scrolledPast) {
      bar.classList.toggle('is-visible', scrolledPast);
      syncBar();
    }
  };

  window.addEventListener('scroll', updateBarVisibility, { passive: true });
  window.addEventListener('resize', updateBarVisibility);
  new MutationObserver(syncBar).observe(productInfo, { childList: true, subtree: true, characterData: true });
  updateBarVisibility();
  syncBar();
})();
